import { useContext } from 'react';
import './RotationPrompt.scss';
import { AuthContext } from '../../context/AuthContext';
import { useTranslation } from '../../i18n/i18n';
import rotationDeviceIcon from '../../assets/icons/rotation_device.svg';

/**
 * Component that displays a device icon prompting users to rotate their device to landscape mode
 * This is shown when the app is in portrait mode on tablets/mobile devices
 */
const RotationPrompt = () => {
  const { currentUser } = useContext(AuthContext);
  const { t } = useTranslation(currentUser?.info?.languageCode);

  return (
    <div className='fixed top-0 left-0 h-screen w-screen z-[9999] bg-[#FFFFFF] dark:bg-[#0F172A] flex flex-col items-center justify-center gap-11'>
      <img src={rotationDeviceIcon} alt='Rotation device' className='size-[12.5rem]' aria-hidden='true' />
      <div className='flex flex-col items-center justify-center gap-2'>
        <h2 className='text-3xl font-semibold text-[#16192C] dark:text-[#FAFAFA]'>{t('rotation_prompt_title')}</h2>
        <p className='text-xl text-[#5C5E6B] dark:text-[#CAD5E2]'>{t('rotation_prompt_message')}</p>
        {/* <p className='mt-2 text-sm font-medium text-[#4B4B4B] dark:text-[#CAD5E2] bg-[#F5F5F5] dark:bg-[#1A202E] border border-[#E1E1E1] dark:border-[#3C3E53] rounded-md px-4 py-2'>
          {t('rotation_prompt_orientation').replace('{orientation}', 'portrait')}
        </p> */}
      </div>
    </div>
  );
};

export default RotationPrompt;
